module.exports = __webpack_public_path__ + "img/filter-type-oberkoerper--active.5d7a61e7.svg";